import initialState from './initialState';

import {
  FETCHING_TAX_EXPENSE_REPORT_SUCCESS,
  SELECT_VIEW_TYPE,
  SELECT_DETAIL_AGGREGATION_TYPE,
  SELECT_REPORT_BOOK_TYPE,
  SELECT_REPORT_BOOK_TYPES,
  SELECT_GROUP_TYPE,
  FETCH_TAX_EXPENSE_REPORT,
  FETCH_TAX_EXPENSE_REPORT_FOR_ALL_PILLS,
  FETCH_TAX_EXPENSE_REPORT_FOR_ALL_PILLS_SUCCESS,
  FETCH_TAX_EXPENSE_REPORT_FOR_ALL_PILLS_FAILURE,
  FETCH_DRILL_DETAIL,
  FETCH_DRILL_DETAIL_SUCCESS,
  FETCH_DRILL_DETAIL_FAILURE,
  SELECT_ENTRY_FOR_DRILL_DETAIL,
  SELECT_COMPANY_CODE_TO_FILTER,
  SELECT_CUSTOM_GROUP,
  RESET_TAX_EXPENSE_REPORT,
  SELECT_COUNTRY_TAX_TYPE,
  FETCH_COUNTRY_TAX_TYPES,
  FETCH_COUNTRY_TAX_TYPES_SUCCESS,
  FETCH_COUNTRY_TAX_TYPES_FAILURE,
} from './types';

import { LOGOUT_SUCCESS } from '../../../userData/store/types';

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case LOGOUT_SUCCESS:
      return {
        ...initialState,
      };

    case FETCH_TAX_EXPENSE_REPORT:
      return {
        ...state,
        reportData: initialState.reportData,
        taxExpenseLoading: true,
      };

    case FETCHING_TAX_EXPENSE_REPORT_SUCCESS:
      return {
        ...state,
        taxExpenseLoading: false,
        reportData: action.reportData,
        reportDataByBookType: action.reportDataByBookType || {},
        customGroupOptions: action.customGroupOptions,
      };

    case RESET_TAX_EXPENSE_REPORT:
      return {
        ...state,
        reportData: initialState.reportData,
        reportDataByBookType: initialState.reportDataByBookType,
        customGroupOptions: initialState.customGroupOptions,
        customGroup: initialState.customGroup,
      };

    case SELECT_VIEW_TYPE:
      return {
        ...state,
        viewType: action.viewType,
      };

    case SELECT_REPORT_BOOK_TYPE:
      return {
        ...state,
        reportBookType: action.reportBookType,
        selectedReportBookTypes: action.selectedReportBookTypes || state.selectedReportBookTypes,
        reportData: action.reportData || initialState.reportData,
        countryTaxType: initialState.countryTaxType,
      };

    case SELECT_REPORT_BOOK_TYPES:
      return {
        ...state,
        selectedReportBookTypes: action.selectedReportBookTypes,
      };

    case SELECT_GROUP_TYPE:
      return {
        ...state,
        groupType: action.groupType,
        companyCodeToFilter: initialState.companyCodeToFilter,
        customGroup: initialState.customGroup,
      };

    case FETCH_TAX_EXPENSE_REPORT_FOR_ALL_PILLS:
      return {
        ...state,
        isExportingReportForAllPills: true,
      };

    case FETCH_TAX_EXPENSE_REPORT_FOR_ALL_PILLS_SUCCESS:
    case FETCH_TAX_EXPENSE_REPORT_FOR_ALL_PILLS_FAILURE:
      return {
        ...state,
        isExportingReportForAllPills: false,
      };

    case FETCH_DRILL_DETAIL:
      return {
        ...state,
        isDrillDetailLoading: true,
      };

    case FETCH_DRILL_DETAIL_SUCCESS:
      return {
        ...state,
        isDrillDetailLoading: false,
        drillDetail: action.drillDetail,
      };

    case FETCH_DRILL_DETAIL_FAILURE:
      return {
        ...state,
        isDrillDetailLoading: false,
      };

    case SELECT_ENTRY_FOR_DRILL_DETAIL:
      return {
        ...state,
        selectedEntry: {
          countryTaxType: action.countryTaxType,
          columnTitle: action.columnTitle,
          reportLineType: action.reportLineType,
          groupItem: action.groupItem,
          cellToElevateSelector: action.cellToElevateSelector,
        },
      };

    case SELECT_COMPANY_CODE_TO_FILTER:
      return {
        ...state,
        companyCodeToFilter: action.companyCodeToFilter,
      };
    case SELECT_CUSTOM_GROUP:
      return {
        ...state,
        customGroup: action.customGroup,
      };

    case FETCH_COUNTRY_TAX_TYPES: {
      return {
        ...state,
        isFetchingCountryTaxTypes: true,
      };
    }
    case FETCH_COUNTRY_TAX_TYPES_SUCCESS: {
      return {
        ...state,
        isFetchingCountryTaxTypes: false,
        countryTaxTypesOptions: action.countryTaxTypes,
      };
    }
    case FETCH_COUNTRY_TAX_TYPES_FAILURE: {
      return {
        ...state,
        isFetchingCountryTaxTypes: false,
      };
    }

    case SELECT_COUNTRY_TAX_TYPE: {
      return {
        ...state,
        countryTaxType: action.countryTaxType,
      };
    }

    case SELECT_DETAIL_AGGREGATION_TYPE:
      return {
        ...state,
        detailAggregationType: action.detailAggregationType,
      };

    default:
      return state;
  }
}
